var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 18.6668 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.33344 11.4167H5.58344C4.42047 11.4167 3.83899 11.4167 3.36582 11.5602C2.30049 11.8834 1.46681 12.717 1.14364 13.7824C1.00011 14.2555 1.00011 14.837 1.00011 16M12.6668 13.5L14.3334 15.1667L17.6668 11.8333M11.4168 4.75C11.4168 6.82107 9.73784 8.5 7.66677 8.5C5.59571 8.5 3.91677 6.82107 3.91677 4.75C3.91677 2.67893 5.59571 1 7.66677 1C9.73784 1 11.4168 2.67893 11.4168 4.75Z",
    stroke: "var(--stroke-0, black)",
    strokeWidth: 1.56,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminNew);
export default __webpack_public_path__ + "static/media/admin-new.be3ffb160feaa83711d386cf52f9d16d.svg";
export { ForwardRef as ReactComponent };